import React, { useState, useMemo } from 'react';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';


// Family cards: a grey header with the name and count, members inside, each
// class as a chip coloured by show. Andrew, 2026-10-12: "visually separating
// family cards just a little more".
const SHOW_CHIP = [
    { bg:'#e6f7fd', bd:'#a8dff2', fg:'#1a94ba' },
    { bg:'#f0f8f0', bd:'#a0dbb0', fg:'#2ab568' },
    { bg:'#f5edff', bd:'#c8a0f0', fg:'#8b35c8' },
    { bg:'#fff4e4', bd:'#f0c87a', fg:'#d4820a' },
    { bg:'#fdeef2', bd:'#f0a8bc', fg:'#c0335a' },
];
const F = {
    card:   { marginTop:8, border:'1px solid #e8e8f2', borderRadius:10, background:'#fff', overflow:'hidden', cursor:'pointer' },
    top:    { display:'flex', alignItems:'center', gap:8, padding:'9px 11px', background:'#fafafd', borderBottom:'1px solid #f0f0f8', listStyle:'none' },
    name:   { display:'block', fontSize:13, fontWeight:700, color:'#3f3f55' },
    sub:    { display:'block', fontSize:11, color:'#8a8aa8', marginTop:1 },
    ok:     { marginLeft:'auto', fontSize:11, padding:'3px 8px', border:'1px solid #c8e6d0', borderRadius:6, background:'#eefaf1', color:'#1f8a44',
              cursor:'pointer', whiteSpace:'nowrap', flexShrink:0, fontFamily:'inherit' },
    body:   { padding:'6px 11px 8px', cursor:'default' },
    member: { display:'flex', alignItems:'baseline', gap:8, padding:'4px 0', borderBottom:'1px solid #f7f7fb', fontSize:11 },
    mn:     { fontWeight:600, minWidth:100, color:'#3f3f55', flexShrink:0 },
    mw:     { display:'flex', flexWrap:'wrap', gap:4, color:'#6b6b8a' },
    chip:   (i) => { const c = SHOW_CHIP[(i ?? 0) % SHOW_CHIP.length]; return {
              background:c.bg, border:`1px solid ${c.bd}`, color:c.fg, borderRadius:4, padding:'1px 6px', whiteSpace:'nowrap', fontSize:10 }; },
};

const S = {
    panel:    { width:300, flexShrink:0, background:'#fff', borderLeft:'1px solid #e0e0ec',
                display:'flex', flexDirection:'column' },
    tabs:     { display:'flex', borderBottom:'1px solid #e0e0ec', flexShrink:0 },
    tab:      (a) => ({ flex:1, padding:'11px 0', fontSize:13, fontWeight: a?600:400,
                color: a?'#29b8e5':'#6b6b8a', background:'none', border:'none',
                borderBottom: a?'2px solid #29b8e5':'2px solid transparent', cursor:'pointer' }),
    // Summary tab
    scroll:   { overflowY:'auto', flex:1, padding:'16px 0' },
    section:  { borderBottom:'1px solid #e0e0ec' },
    secHdr:   (a) => ({ display:'flex', alignItems:'center', justifyContent:'space-between',
                padding:'12px 16px', cursor:'pointer', userSelect:'none',
                background: a?'#f8f8fc':'transparent' }),
    secTitle: { fontSize:13, fontWeight:600, color:'#3f3f55' },
    secBody:  { padding:'0 16px 14px' },
    empty:    { fontSize:12, color:'#6b6b8a', fontStyle:'italic', paddingTop:8 },
    label:    { fontSize:12, color:'#6b6b8a', marginBottom:4, display:'block', marginTop:10 },
    input:    { width:'100%', border:'1px solid #e0e0ec', borderRadius:6, padding:'7px 10px',
                fontSize:13, color:'#3f3f55', outline:'none', boxSizing:'border-box' },
    warnItem: { fontSize:12, color:'#3f3f55', padding:'6px 0', borderBottom:'1px solid #f0f0f8' },
    warnSub:  { fontSize:11, color:'#6b6b8a', marginTop:2 },
    // Library tab
    libWrap:  { display:'flex', flexDirection:'column', flex:1, overflow:'hidden' },
    libTop:   { padding:'10px 12px', borderBottom:'1px solid #e0e0ec', flexShrink:0 },
    select:   { width:'100%', border:'1px solid #e0e0ec', borderRadius:7, padding:'6px 10px',
                fontSize:12, color:'#3f3f55', outline:'none', background:'#fff', cursor:'pointer',
                marginBottom:8 },
    row2:     { display:'flex', gap:6, marginBottom:8, alignItems:'center' },
    groupLabel:{ fontSize:11, color:'#6b6b8a', whiteSpace:'nowrap' },
    groupSel: { flex:1, border:'1px solid #e0e0ec', borderRadius:7, padding:'5px 8px',
                fontSize:12, color:'#3f3f55', outline:'none', background:'#fff', cursor:'pointer' },
    searchWrap:{ position:'relative' },
    searchIcon:{ position:'absolute', left:8, top:'50%', transform:'translateY(-50%)',
                color:'#6b6b8a', pointerEvents:'none', fontSize:13 },
    searchInput:{ width:'100%', border:'1px solid #e0e0ec', borderRadius:7,
                  padding:'6px 8px 6px 28px', fontSize:12, outline:'none', boxSizing:'border-box',
                  color:'#3f3f55', background:'#fff' },
    // Bulk bar
    bulkBar:  { background:'#e6f7fd', borderBottom:'1px solid #c5eaf7', padding:'8px 12px',
                display:'flex', alignItems:'center', gap:8, flexShrink:0 },
    bulkText: { fontSize:12, color:'#29b8e5', flex:1 },
    bulkBtn:  { background:'#29b8e5', color:'#fff', border:'none', borderRadius:6,
                padding:'5px 10px', fontSize:11, fontWeight:600, cursor:'pointer', whiteSpace:'nowrap' },
    bulkX:    { background:'none', border:'none', color:'#29b8e5', cursor:'pointer',
                fontSize:16, lineHeight:1, padding:'2px 4px' },
    // List
    libList:  { overflowY:'auto', flex:1 },
    grpHdr:   { display:'flex', alignItems:'center', gap:8, padding:'6px 12px',
                background:'#f8f8fc', borderBottom:'1px solid #e0e0ec',
                position:'sticky', top:0, zIndex:1 },
    grpCb:    { width:13, height:13, accentColor:'#29b8e5', cursor:'pointer', flexShrink:0 },
    grpName:  { fontSize:11, fontWeight:600, color:'#6b6b8a', textTransform:'uppercase',
                letterSpacing:'0.04em', flex:1 },
    grpCount: { fontSize:10, color:'#9b9bb8' },
    clsRow:   (sel, inCur) => ({
        display:'flex', alignItems:'center', gap:8, padding:'7px 12px',
        borderBottom:'1px solid #f4f4f8', cursor:'pointer',
        background: sel ? '#e6f7fd' : inCur ? '#f4feff' : '#fff',
        transition:'background 0.1s',
    }),
    clsCb:    { width:13, height:13, accentColor:'#29b8e5', cursor:'pointer', flexShrink:0 },
    clsDot:   (color) => ({ width:8, height:8, borderRadius:2,
                background: color || '#e0e0ec', flexShrink:0 }),
    clsName:  { fontSize:12, fontWeight:600, color:'#3f3f55', flex:1,
                whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' },
    clsMeta:  { fontSize:10, color:'#6b6b8a', marginTop:1 },
    badges:   { display:'flex', gap:2, flexShrink:0 },
    badge:    (cur, inShow) => ({
        fontSize:9, fontWeight:600, padding:'2px 5px', borderRadius:4, border:'1px solid',
        background: cur ? '#29b8e5' : inShow ? '#e6f7fd' : '#f2f3f9',
        borderColor: cur ? '#29b8e5' : inShow ? '#c5eaf7' : '#e0e0ec',
        color: cur ? '#fff' : inShow ? '#29b8e5' : '#9b9bb8',
    }),
};

function Section({ title, badge, warn, children, defaultOpen=true }) {
    const [open, setOpen] = useState(defaultOpen);
    return (
        <div style={S.section}>
            <div style={S.secHdr(open)} onClick={() => setOpen(o=>!o)}>
                <span style={{ ...S.secTitle, color: warn?'#e07b2a':'#3f3f55' }}>
                    {warn && '⚠ '}{title}{badge>0?` (${badge})`:''}
                </span>
                {open ? <FiChevronDown size={14} color="#6b6b8a"/> : <FiChevronRight size={14} color="#6b6b8a"/>}
            </div>
            {open && <div style={S.secBody}>{children}</div>}
        </div>
    );
}

// Builds { actId: "Adv Jazz (3)" } for one show's running order.
const labelActs = (acts) => {
    const map = {};
    let n = 0;
    [...(acts || [])].sort((a, b) => (a.position ?? 0) - (b.position ?? 0)).forEach((a) => {
        if (a.type === 'class') n += 1;
        const cls = a.recitalClass || a.scheduleSticker;
        const name = cls?.className || a.label || (a.type === 'intermission' ? 'Intermission' : 'Untitled');
        map[a.id] = a.type === 'class' ? `${name} (${n})` : name;
    });
    return map;
};

const QuickChangeList = ({ quickChanges, labels }) => quickChanges.map((qc, i) => (
    <div key={i} style={S.warnItem}>
        <div style={{ fontWeight:600, fontSize:12 }}>{qc.studentName}</div>
        <div style={S.warnSub}>
            {labels[qc.actIdA] || `Act ${qc.actA}`} → {labels[qc.actIdB] || `Act ${qc.actB}`} ({qc.gap === 0 ? 'back to back' : `${qc.gap} act${qc.gap !== 1 ? 's' : ''} apart`})
        </div>
    </div>
));

// `groups` (board view): [{ name, acts, quickChanges }] for every show, so the
// panel lists them all, grouped by show, instead of guessing which show the
// owner means. Andrew, 2026-10-12: "grouped by show is fine". Without it
// (running order), `acts` and `quickChanges` are the open show's.
export default function RightPanel({ acts, quickChanges = [], groups = null,
                                     familyConflicts = [], quietedFamilies = [], onFamilyAllGood, onFamilyUndo }) {

    // Quick changes come from the server as act ids plus a slot count that includes
    // intermissions. The owner reads the dance name and the number printed on its
    // card, so build "Adv Jazz (3)" from the running order. Andrew, 2026-10-12:
    // "needs to be like Adv Jazz (1), not just act 1".
    const actLabels = useMemo(() => labelActs(acts), [acts]);
    const groupLabels = useMemo(() => (groups || []).map((g) => labelActs(g.acts)), [groups]);
    const qcTotal = groups ? groups.reduce((n, g) => n + (g.quickChanges || []).length, 0) : quickChanges.length;


    return (
        <div style={S.panel}>
                <div style={S.scroll}>
                    {!groups && (
                        <Section title="Show order">
                            <div style={{ fontSize:12, color:'#6b6b8a', paddingTop:4 }}>
                                <div><span style={{ fontWeight:600, color:'#3f3f55' }}>{acts.filter(a=>a.type==='class').length}</span> acts</div>
                            </div>
                        </Section>
                    )}
                    <Section title="Quick changes" badge={qcTotal} warn={qcTotal>0} defaultOpen={qcTotal>0}>
                        {groups ? (
                            <>
                                <p style={{ ...S.empty, fontStyle:'normal', marginBottom:4 }}>Same dancer too close together. Every show, grouped.</p>
                                {groups.map((g, gi) => (
                                    <div key={g.id ?? gi} style={{ marginTop:10 }}>
                                        {/* A band per show, coloured like the family chips, so the split is
                                            obvious in a long list. Andrew, 2026-10-12: "impossible to see". */}
                                        <div style={{ display:'flex', alignItems:'center', gap:8, padding:'6px 10px', borderRadius:7,
                                            background: SHOW_CHIP[gi % SHOW_CHIP.length].bg, border:`1px solid ${SHOW_CHIP[gi % SHOW_CHIP.length].bd}`,
                                            color: SHOW_CHIP[gi % SHOW_CHIP.length].fg, fontSize:12, fontWeight:700, position:'sticky', top:0, zIndex:1 }}>
                                            {g.name}
                                            <span style={{ marginLeft:'auto', fontSize:11, fontWeight:600, opacity:.85 }}>
                                                {g.quickChanges?.length ? `${g.quickChanges.length} quick change${g.quickChanges.length === 1 ? '' : 's'}` : 'none'}
                                            </span>
                                        </div>
                                        <QuickChangeList quickChanges={g.quickChanges || []} labels={groupLabels[gi] || {}} />
                                    </div>
                                ))}
                            </>
                        ) : quickChanges.length === 0
                            ? <p style={S.empty}>No quick changes detected.</p>
                            : <QuickChangeList quickChanges={quickChanges} labels={actLabels} />
                        }
                    </Section>
                    <Section title="Families" badge={familyConflicts.length} warn={familyConflicts.length>0} defaultOpen={familyConflicts.length>0 || quietedFamilies.length>0}>
                        {familyConflicts.length === 0 ? (
                            <p style={S.empty}>No families split across shows.</p>
                        ) : (
                            <>
                                <p style={{ fontSize:11, color:'#6b6b8a', marginBottom:8, lineHeight:1.5 }}>
                                    Same last name in more than one show, so the family comes more than once.
                                    Open one to see who and where. "All good" quiets a family that is fine with it.
                                </p>
                                {familyConflicts.map((fc) => (
                                    <details key={fc.lastName} style={F.card}>
                                        <summary style={F.top}>
                                            <span style={{ minWidth:0 }}>
                                                <span style={F.name}>{fc.lastName} family</span>
                                                <span style={F.sub}>
                                                    {fc.members.length} dancer{fc.members.length !== 1 ? 's' : ''} · {fc.shows.join(', ')}
                                                </span>
                                            </span>
                                            {onFamilyAllGood && (
                                                <button type="button" title="This family is fine coming to more than one show"
                                                    onClick={(e) => { e.preventDefault(); onFamilyAllGood(fc.lastName); }}
                                                    style={F.ok}>
                                                    All good ✓
                                                </button>
                                            )}
                                        </summary>
                                        <div style={F.body}>
                                            {fc.members.map((m) => (
                                                <div key={m.name} style={F.member}>
                                                    <span style={F.mn}>{m.name}</span>
                                                    <span style={F.mw}>
                                                        {(m.places || []).map((p, i) => (
                                                            <span key={i} style={F.chip(p.showIdx)}>{p.show} · {p.className}</span>
                                                        ))}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </details>
                                ))}
                            </>
                        )}
                        {quietedFamilies.length > 0 && (
                            <div style={{ marginTop:10 }}>
                                <div style={{ fontSize:10, color:'#9b9bb8', textTransform:'uppercase', letterSpacing:0.4, marginBottom:4 }}>
                                    Marked all good
                                </div>
                                {quietedFamilies.map((fc) => (
                                    <div key={fc.lastName} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', fontSize:11, color:'#9b9bb8', padding:'3px 0' }}>
                                        <span>{fc.lastName} family · {fc.shows.join(' · ')}</span>
                                        {onFamilyUndo && (
                                            <button type="button" onClick={() => onFamilyUndo(fc.lastName)}
                                                style={{ fontSize:11, background:'none', border:'none', color:'#29b8e5', cursor:'pointer', textDecoration:'underline' }}>
                                                Undo
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </Section>
                </div>
        </div>
    );
}
